<template>
  <!-- 退件单下单记录 -->
  <div>
    <el-form class="selectClass" label-position="top" size="small">
      <el-row justify="start" style="flex-wrap: wrap; align-items: center" type="flex">
        <el-col :span="6">
          <el-form-item :label="$t('basicData.OperationTime')">
            <el-date-picker
              v-model="timeValue"
              :clearable="true"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('collectionCenter.EndTime')"
              :start-placeholder="$t('collectionCenter.StartTime')"
              range-separator="~"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="dateChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('collectionCenter.CustomerName')">
            <el-select
              v-model="queryForm.params.customerId"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              remote
              reserve-keyword
              @change="getCustomerPage"
              @clear="getCustomerPage"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.customerAlias + '(' + item.username + ')'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('collectionCenter.OperationSite')">
            <el-select
              v-model="queryForm.params.siteId"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              :remote-method="remoteGetSiteList"
              clearable
              filterable
              remote
              reserve-keyword
              @change="remoteGetSiteList"
              @clear="remoteGetSiteList"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('collectionCenter.operator')">
            <el-select
              v-model="queryForm.params.createUser"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              :remote-method="getOperator"
              clearable
              filterable
              remote
              reserve-keyword
              @change="getOperator"
              @clear="getOperator"
            >
              <el-option
                v-for="(item, index) in operatorList"
                :key="index"
                :label="item.realName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <template #label>
              <el-select
                v-model="chooseOrder"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                class="selectClass01"
                filterable
                size="small"
                @change="changeNum"
              >
                <el-option
                  :label="$t('collectionCenter.returnWaybillNumber')"
                  :value="1"
                /><!-- 退件运单号 -->
                <el-option
                  :label="$t('collectionCenter.originalWaybillNumber')"
                  :value="2"
                /><!-- 原始运单号 -->
                <el-option
                  :label="$t('collectionCenter.returnOrderNumber')"
                  :value="3"
                /><!-- 退件单订单号 -->
              </el-select>
            </template>
            <el-input
              v-model="returnOrder"
              :placeholder="$t('collectionCenter.max2000Line')"
              autosize
              clearable
              type="textarea"
              @blur="ft"
              @keydown.enter.native="BlockNewlineNum"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('collectionCenter.orderPlacementResult')">
            <el-select
              v-model="queryForm.params.operateStatus"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
            >
              <el-option :label="$t('collectionCenter.tudo')" :value="null" /><!-- 全部 -->
              <el-option
                :label="$t('orderCenterCont.orderWasPlacedSuccessfully')"
                :value="1"
              /><!-- 下单成功 -->
              <el-option :label="$t('newOrder.FailedOrder')" :value="0" /><!-- 下单失败 -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" style="margin-left: 10px">
          <el-button size="small" type="primary" @click="searchClick">
            {{ $t('operationCenter.Procurar') }} </el-button><!-- 搜索 -->
          <el-button size="small" type="info" @click="resetClick">
            {{ $t('collectionCenter.reset') }}
          </el-button>
          <!-- 重置 -->
          <el-button size="small" type="primary" @click="download">
            {{ $t('collectionCenter.export') }} </el-button><!-- 导出 -->
        </el-col>
      </el-row>
    </el-form>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      :max-height="620"
      border
      style="width: 100%"
    >
      <!-- 序号 -->
      <el-table-column :label="$t('collectionCenter.ind')" align="center" width="60">
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- 退件运单号 -->
      <el-table-column
        :label="$t('collectionCenter.returnWaybillNumber')"
        align="center"
        prop="waybillNumber"
      >
        <template slot-scope="scope">
          <div style="color: #4fa5ff; cursor: pointer" @click="viewDetails(scope.row)">
            {{ scope.row.waybillNumber }}
          </div>
        </template>
      </el-table-column>
      <!-- 原始运单号 -->
      <el-table-column
        :label="$t('collectionCenter.originalWaybillNumber')"
        align="center"
        prop="forwardWaybillNumber"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.forwardWaybillNumber || '--' }}</div>
        </template>
      </el-table-column>
      <!-- 客户名称 -->
      <el-table-column
        :label="$t('collectionCenter.CustomerName')"
        align="center"
        prop="customerName"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.customerName || '--' }}</div>
        </template>
      </el-table-column>
      <!-- 下单结果 -->
      <el-table-column
        :label="$t('collectionCenter.orderPlacementResult')"
        align="center"
        prop="operateStatusValue"
      />
      <!-- 退件单最新轨迹 -->
      <el-table-column
        :label="$t('collectionCenter.latestReturnTrack')"
        align="center"
        prop="lastTrackDescribe"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.lastTrackDescribe || '--' }}</div>
        </template>
      </el-table-column>
      <!-- 操作人 -->
      <el-table-column
        :label="$t('collectionCenter.operator')"
        align="center"
        prop="createUserName"
      />
      <!-- 操作网点 -->
      <el-table-column
        :label="$t('collectionCenter.OperationSite')"
        align="center"
        prop="siteName"
      />
      <!-- 操作时间 -->
      <el-table-column :label="$t('basicData.OperationTime')" align="center" prop="createTime" />
      <el-table-column :label="$t('collectionCenter.operation')" align="center" width="110">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.operateStatus !== 0"
            size="mini"
            @click="printClick(scope.row)"
          >
            {{ $t('collectionCenter.Print') }} </el-button><!-- 打印 -->
        </template>
      </el-table-column>
    </el-table>
    <div class="right">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100, 500, 1000]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="searchClick"
        @size-change="searchClick1"
      />
    </div>
    <!--运单详情-->
    <el-drawer
      :append-to-body="true"
      :title="$t('collectionCenter.returnNote')"
      :visible.sync="waybillDescription.visible"
      custom-class="drawerClass"
      direction="ltr"
      size="90%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <waybill-information
          :key="showQueryTrack.trackKey"
          :query-track-param="TrackParam"
          query-type="1"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import dayjs from 'dayjs';

import { apiCustomerPage } from '@/api/customer';
import { queryRealName, siteFuzzyQuery } from '@/api/lanshou';
import {
  reverseOrderWaybillRecordExport,
  reverseOrderWaybillRecordPage
} from '@/api/automaticSorting';

import { batchPdfDownload } from '@/utils/PDF_util';
import { saveAs } from 'file-saver';
import { setDateTime2 } from '@/utils/date_util';

import waybillInformation from '@/views/orderCenter/logisticsOrders/components/waybillInformation/waybillInformation.vue';

import { goRWExportList } from '@/utils/goExportList.js';
import { downloadExpressLabeling } from '@/api/logisticsOrders';

export default {
  name: 'ReturnNoteRecord',
  components: {
    waybillInformation
  },
  data() {
    return {
      timeValue: [],
      chooseOrder: 1,
      notEnter: true, // 是否允许换行
      customerList: [], // 客户列表
      siteList: [], // 网点列表
      operatorList: [],
      returnOrder: '',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          createStartTime: '',
          createEndTime: '',
          customerId: '',
          siteId: '',
          createUser: '',
          waybillNumbers: [],
          forwardWaybillNumbers: [],
          orderNumbers: [],
          operateStatus: null
        }
      },
      total: 0,
      tableData: [],
      TrackParam: {}, // 轨迹详情,
      showQueryTrack: {
        trackKey: new Date().getTime()
      },
      waybillDescription: {
        visible: false
      }
    };
  },
  watch: {
    returnOrder(val) {
      let bgh = val.split('\n');
      // 过滤空项
      bgh = bgh.filter(function(f) {
        return f && f.trim();
      });
      // 去除空格
      const bghTrim = bgh.map((item) => {
        return item.replace(/\s/g, '').trim();
      });
      let number = [];
      if (bghTrim.length >= 2000) {
        number = bghTrim.slice(0, 2000).join('\n');
        this.returnOrder = number;
        this.notEnter = false;
      } else {
        this.notEnter = true;
      }
      if (bghTrim.length > 2000) {
        this.$message.warning(this.$t('collectionCenter.intercep2'));
      }
    }
  },
  created() {
    this.default();
    this.getCustomerPage('');
    this.remoteGetSiteList('');
    this.getOperator('');
    this.searchClick();
  },
  methods: {
    dateChange(val) {
      if (val === null || val === undefined) {
        this.timeValue = [];
        this.queryForm.params.createStartTime = '';
        this.queryForm.params.createEndTime = '';
        return;
      }
      this.queryForm.params.createStartTime = val[0];
      this.queryForm.params.createEndTime = val[1];
    },
    changeNum() {
      this.returnOrder = '';
      this.queryForm.params.waybillNumbers = [];
      this.queryForm.params.forwardWaybillNumbers = [];
      this.queryForm.params.orderNumbers = [];
    },
    ft() {
      const val = this.returnOrder.split('\n');
      // 过滤空项
      const numLen = val.filter(function(f) {
        return f && f.trim();
      });
      // 去除空格
      const numTrim = numLen.map((item) => {
        return item.replace(/\s/g, '').trim();
      });
      this.returnOrder = numTrim.join('\n');
      this.queryForm.params.waybillNumbers = [];
      this.queryForm.params.forwardWaybillNumbers = [];
      this.queryForm.params.orderNumbers = [];
      if (this.chooseOrder === 1) {
        this.queryForm.params.waybillNumbers = numTrim;
      }
      if (this.chooseOrder === 2) {
        this.queryForm.params.forwardWaybillNumbers = numTrim;
      }
      if (this.chooseOrder === 3) {
        this.queryForm.params.orderNumbers = numTrim;
      }
    },
    BlockNewlineNum() {
      // 文本域最大输入行数为2000
      const e = window.event || arguments[0];
      this.ft();
      const numberLen = this.returnOrder.split('\n');
      if (!this.notEnter) {
        if (numberLen.length >= 2000) {
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
        e.returnValue = false;
        return true;
      }
    },
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    getOperator(name) {
      const nameVal = name || '';
      queryRealName(nameVal)
        .then((res) => {
          if (res.code === 200) {
            this.operatorList = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    default() {
      // 默认
      this.chooseOrder = 1;
      this.returnOrder = '';
      const d = new Date();
      const today = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
      this.queryForm.params = {
        createStartTime: today + ' 00:00:00',
        createEndTime: today + ' 23:59:59',
        customerId: '',
        siteId: '',
        createUser: '',
        waybillNumbers: [],
        forwardWaybillNumbers: [],
        orderNumbers: [],
        operateStatus: null
      };
    },
    resetClick() {
      this.default();
      this.getCustomerPage('');
      this.remoteGetSiteList('');
      this.getOperator('');
    },
    searchClick() {
      if (!this.returnOrder && (!this.timeValue || this.timeValue.length <= 0)) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime')); // 请选择日期时间
        return;
      }
      if (!this.timeValue || this.timeValue.length <= 0) {
        this.queryForm.params.createStartTime = '';
        this.queryForm.params.createEndTime = '';
      }
      reverseOrderWaybillRecordPage(this.queryForm).then((res) => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    searchClick1() {
      this.queryForm.pageNumber = 1;
      this.searchClick();
    },
    viewDetails(row) {
      this.TrackParam = row;
      this.showQueryTrack.trackKey = new Date().getTime();
      this.waybillDescription.visible = true;
    },
    download() {
      if (this.tableData.length <= 0) {
        this.$message.warning(this.$t('operationCenter.noDataExported')); // 列表暂无数据，无法导出
        return;
      }
      reverseOrderWaybillRecordExport(this.queryForm.params).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    printClick(row) {
      // 手动显示加载中动画
      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$i18n.t('orderCenterCont.DesperatelyLoading'), // '拼命加载中',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      batchPdfDownload([row.labelUrl])
        .then((res) => {
          const dateType = setDateTime2();
          const saveName = `${dateType}` + this.$i18n.t('orderCenterCont.FaceSheet');
          saveAs(res, saveName);
          this.getLog(row.waybillNumber);
        })
        .finally(() => {
          loading.close();
        });
    },
    async getLog(waybillNumber) {
      const data = { numberLists: [waybillNumber] };
      await downloadExpressLabeling(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.selectClass ::v-deep .el-range-editor {
  width: auto;
}

.selectClass ::v-deep .el-form-item {
  margin-left: 10px;
}

.selectClass ::v-deep .el-select {
  width: 100%;
}

.selectClass ::v-deep .selectClass01 .el-input__inner {
  font-weight: 600 !important;
}

.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
